import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogoXero = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 49 48'
    {...props}
  >
    <g clipPath='url(#Logo_Xero_svg__a)'>
      <path
        fill='#13B5EA'
        d='M24.614.048c-13.256 0-24 10.604-24 23.684 0 13.079 10.744 23.684 24 23.684 13.252 0 24-10.605 24-23.684S37.867.048 24.615.048'
      />
      <path
        fill='#fff'
        d='M18.208 22.74a3.805 3.805 0 0 1 3.693-2.857 3.8 3.8 0 0 1 3.697 2.857zm8.732 1.022c.247-.304.34-.7.261-1.12-.322-1.516-1.149-2.73-2.392-3.512a5.37 5.37 0 0 0-2.882-.827 5.4 5.4 0 0 0-3.133.987 5.41 5.41 0 0 0-2.276 4.411c0 .44.055.877.162 1.298a5.44 5.44 0 0 0 4.585 4.017q.32.039.631.039c.44 0 .867-.056 1.307-.17a5.4 5.4 0 0 0 1.619-.685c.475-.307.912-.72 1.372-1.296l.03-.03a.9.9 0 0 0 .196-.672.75.75 0 0 0-.286-.514.84.84 0 0 0-.503-.179c-.17 0-.42.062-.645.355l-.018.023c-.075.1-.152.201-.24.303a4 4 0 0 1-1.039.833 3.8 3.8 0 0 1-1.766.447c-1.951-.021-3.146-1.315-3.613-2.516a4 4 0 0 1-.16-.597l-.002-.057 7.554-.001c.525-.011.964-.202 1.238-.537M37.95 22.241c-.76 0-1.376.613-1.376 1.367 0 .753.617 1.367 1.375 1.367.757 0 1.373-.614 1.373-1.367 0-.754-.616-1.367-1.373-1.367M32.938 19.161a.78.78 0 0 0-.785-.778l-.22-.003c-.67 0-1.304.204-1.838.592a.78.78 0 0 0-1.518.237l.003 8.967a.778.778 0 0 0 1.557 0V22.66c0-1.786.154-2.533 1.708-2.725.13-.015.268-.016.303-.016.457-.016.79-.336.79-.759'
      />
      <path
        fill='#fff'
        d='m12.436 23.666 4.032-4.028a.76.76 0 0 0 .228-.545.781.781 0 0 0-1.339-.545l-4.031 4.007-4.048-4.015a.782.782 0 0 0-1.33.553c0 .208.083.405.234.555l4.035 4.014-4.029 4.02a.76.76 0 0 0-.24.558c0 .428.349.777.779.777.204 0 .4-.08.551-.224l4.044-4.024 4.026 4.005a.782.782 0 0 0 1.349-.534c0-.205-.082-.4-.23-.548zM37.948 27.366c-2.083 0-3.777-1.686-3.777-3.758 0-2.075 1.694-3.762 3.777-3.762a3.77 3.77 0 0 1 3.773 3.762c0 2.072-1.692 3.758-3.773 3.758m0-9.122c-2.97 0-5.387 2.406-5.387 5.364 0 2.956 2.417 5.362 5.388 5.362s5.385-2.406 5.385-5.362c0-2.958-2.416-5.364-5.385-5.364'
      />
    </g>
    <defs>
      <clipPath id='Logo_Xero_svg__a'>
        <path fill='#fff' d='M.615 0h48v48h-48z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoXero;
